export function getAfaCodeFormat(value: string) {
  if (!value) return

  // Remove qualquer prefixo antes do "~"
  const cleanCode = value.includes('~') ? value.split('~')[1] : value

  if (cleanCode.length >= 6) {
    return `${cleanCode.slice(0, 5)}-${cleanCode.slice(5)}`
  }

  return cleanCode
}